interface PositionFilterProps {
  selectedPosition: PositionFilterType;
  setSelectedPosition: (selectedFilter: PositionFilterType) => void;
}

export type PositionFilterType = 'Alle' | 'Teknologer' | 'Designere';

const PositionFilter = ({
  selectedPosition,
  setSelectedPosition,
}: PositionFilterProps) => {
  const options: PositionFilterType[] = ['Alle', 'Teknologer', 'Designere'];

  return (
    <div className="flex flex-row w-full no-scrollbar overflow-x-auto mb-24">
      {options.map((option) => (
        <button
          key={option}
          className={`cursor-pointer px-16 py-12 text-lg leading-[1.5] border-b ${
            option === selectedPosition
              ? 'text-blank-yellow bg-blank-blue-secondary border-blank-yellow'
              : 'text-blank-yellow-tint-70 border-blank-yellow-tint-10'
          } transition-bg-1s`}
          onClick={() => setSelectedPosition(option)}
        >
          {option}
        </button>
      ))}
    </div>
  );
};
export default PositionFilter;
